// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".editor-slide-upload[data-v-b11494f6] {\n  margin-bottom: 20px;\n}\n.editor-slide-upload[data-v-b11494f6]  .el-upload--picture-card {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
